"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deploy = void 0;
exports.Deploy = {
    CDK: 'CDK',
};
